exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".npo-charityTitle___2d9B2 {\n  margin-bottom: 20px;\n}\n.categoryDisplay___2Zdnu {\n  display: inline-block;\n}\n.socialShareText___3G2x1 {\n  text-align: center;\n}\np + p {\n  padding-top: 0px;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/pages/fundraiser-charity.less"],"names":[],"mappings":"AAAA;EACE,oBAAoB;CACrB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB","file":"fundraiser-charity.less","sourcesContent":[".npo-charityTitle {\n  margin-bottom: 20px;\n}\n.categoryDisplay {\n  display: inline-block;\n}\n.socialShareText {\n  text-align: center;\n}\np + p {\n  padding-top: 0px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"npo-charityTitle": "npo-charityTitle___2d9B2",
	"categoryDisplay": "categoryDisplay___2Zdnu",
	"socialShareText": "socialShareText___3G2x1"
};